import Vue from 'vue';
let pdfMake = require('pdfmake/build/pdfmake.js');
let pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

Vue.use({
  install(Vue) {
    Vue.prototype.tableToPdfReport = function (tableId, name) {

      tableId = String(tableId);
      name = String(name);

      let defaults = {};
      let myTableData = [];

      $("#"+tableId+" tr").each(function () {

        if ($(this).find('td,th').length > 0) {
          let obj = [];
          $(this).find('td,th').each(function () {
            obj.push($.trim($(this).text()));
          });
          myTableData.push(obj);
        }
      });

      var docDefinition = {
        pageSize: 'A3',
        pageOrientation: 'landscape',
        pageMargins: [10, 10, 10, 10],
        content: [
          {
            table: {
              layout: 'lightHorizontalLines',
              headerRows: 1,
              body: myTableData,
              widths: $.map( myTableData[0], function (d, i) {
                return i===0 ? '*' : '*';
              } ),
            },
          },
        ],
        defaultStyle: {
          fontSize: 12,
          bold: false
        },

      };
      pdfMake.createPdf(docDefinition).download(name);

    };
  }
});



// WEBPACK FOOTER //
// ./src/lib/pdfReport.js